import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { fmtCredits, yieldLabel } from "../../utils/credits";

// Badge de solde qui DÉCRÉMENTE visiblement après une génération :
// on affiche brièvement le delta (« −0,4 ») puis on anime le compteur vers
// la nouvelle valeur, pour que la consommation soit tangible.
const CreditBadge = ({ balance, pending = 0 }) => {
  const [shown, setShown] = useState(Number(balance) || 0);
  const [delta, setDelta] = useState(null);
  const prev = useRef(Number(balance) || 0);

  useEffect(() => {
    const target = Number(balance) || 0;
    const from = prev.current;
    prev.current = target;
    if (from === target) return setShown(target);

    if (target < from) { setDelta(target - from); setTimeout(() => setDelta(null), 1800); }

    // Animation courte du compteur (~450 ms).
    const start = performance.now();
    let raf;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / 450);
      setShown(from + (target - from) * (1 - Math.pow(1 - p, 3)));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [balance]);

  const low = Number(balance) < 1;

  return (
    <Link to="/dashboard/credits" title={yieldLabel(balance)}
      className={`relative flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-semibold transition ${
        low ? "bg-amber-50 text-amber-700 hover:bg-amber-100" : "bg-indigo-50 text-indigo-700 hover:bg-indigo-100"
      }`}>
      <span>⚡</span>
      <span className="tabular-nums">{fmtCredits(shown)} crédits</span>
      {pending > 0 && <span className="text-[10px] opacity-60">(−{fmtCredits(pending)} en cours)</span>}
      {low && <span className="text-[10px] font-bold underline">Recharger</span>}
      {delta != null && (
        <span className="absolute -top-4 right-2 text-[11px] font-bold text-red-500 animate-bounce pointer-events-none">
          {fmtCredits(delta)}
        </span>
      )}
    </Link>
  );
};

export default CreditBadge;
